var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_498_185)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6154 17.2789C33.4973 16.5675 32.9372 15.9228 32.0656 16.732C28.6094 19.8729 25.7923 23.037 24.4541 27.1131C22.7394 32.3992 25.3859 34.2987 26.8889 34.1976C29.6711 34.1304 31.595 31.2008 32.4869 29.1156C33.7222 25.836 34.285 21.7461 33.6154 17.2789Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3717 23.7265C13.7698 23.3293 12.9161 23.3016 12.9167 24.4908C12.8691 29.1609 13.273 33.3779 15.3513 37.1308C18.0607 41.983 21.2532 41.3347 22.2013 40.1639C24.0445 38.0788 23.2045 34.6754 22.2822 32.6035C20.718 29.4676 18.1021 26.2735 14.3717 23.7265Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1324 7.44598C18.6492 6.9107 17.8297 6.66959 17.5323 7.82124C16.3158 12.3302 15.6501 16.5141 16.7216 20.6682C18.1287 26.0444 21.3818 26.2167 22.5929 25.3209C24.8999 23.7643 24.9395 20.2592 24.566 18.0223C23.8375 14.5944 22.1055 10.8467 19.1324 7.44598Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_498_185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeed);
export default __webpack_public_path__ + "static/media/Seed.56f04367921d475fc46feb37a538b042.svg";
export { ForwardRef as ReactComponent };